import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type LayoutStyleKey = 'root' | 'main' | 'topBarWidth' | 'topBarWidthCompact';

export const TOP_BAR_HEIGHT = 120;

export const layoutStyles = {
  root: {
    display: 'flex',
    width: '100%',
  },
  main: {
    width: '100%',
    // Keeps the mobile app banner from covering the end of the page
    paddingBottom: 'var(--app-banner-space, 0px)',
  },
  topBarWidth: {
    height: `${TOP_BAR_HEIGHT}px`,
  },
  topBarWidthCompact: {
    height: '64px',
  },
} satisfies Record<LayoutStyleKey, SystemStyleObject<Theme>>;
